module.exports = __webpack_public_path__ + "img/thumbnail_Dhole_f_normal.653c7f09.png";